import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, Observable, Subject, throwError } from 'rxjs';

import { ErrorHttp } from '../utils/acceso-tanda';

/**
 * Avisa de los 403/404 de la API para que la pantalla de una tanda compartida
 * se entere de que el dueño quitó (o puso en pausa) al co-organizador en
 * cualquier petición, no solo al cargar. No cambia la respuesta.
 */
@Injectable({ providedIn: 'root' })
export class AccesoTandaEventos {
    private readonly _errores = new Subject<ErrorHttp>();
    readonly errores$ = this._errores.asObservable();

    avisar(e: ErrorHttp): void {
        this._errores.next(e);
    }
}

export const accesoTandaInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const eventos = inject(AccesoTandaEventos);
    return next(req).pipe(
        catchError((error) => {
            try {
                if (
                    error instanceof HttpErrorResponse &&
                    (error.status === 403 || error.status === 404) &&
                    req.url.startsWith(environment.apiUrl)
                ) {
                    eventos.avisar({ status: error.status, error: error.error });
                }
            } catch {
                // Nunca romper la petición por avisar.
            }
            return throwError(() => error);
        }),
    );
};
